/**
 * Convert hex color to RGBA with opacity
 * @param hex - Hex color string (e.g., '#008EA2')
 * @param alpha - Opacity value between 0 and 1
 * @returns RGBA color string
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  // Remove # if present
  const cleanHex = hex.replace('#', '');
  
  // Parse hex values
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  
  // Return RGBA string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};